import React from "react";

const Section7 = ({url}) => {
  return (

    <section className="home-section-7">
        <div className="container">

            {/* Heading */}
            <div className="text-center section-header">
            <h2>
                How It Turns <span>Top Talent</span> into <br />
                Your Employees
            </h2>
            <p className="section-desc">
                Organizations using AI hiring software report measurable improvements in speed, efficiency, and decision quality
            </p>
            </div>

            <div className="row d-flex align-items-center justify-content-center">

            {/* Left Steps */}
            <div className="col-lg-6 col-xl-5 col-md-12 steps-col" data-aos="fade-right" data-aos-duration="1000">

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/intelihire/sec-7/1.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Create & Launch Your Job</h5>
                    <p>
                    Post in minutes, not hours. Enter job details, requirements,
                    and qualifications. Get a shareable link instantly to distribute
                    across all your recruitment channels.
                    </p>
                </div>
                </div>

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/intelihire/sec-7/2.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Let AI Find Your Best Matches</h5>
                    <p>
                    Our ai based recruitment platform analyzes every
                    application, generates detailed summaries, and highlights
                    strengths and gaps.
                    </p>
                </div>
                </div>

                <div className="step-card">
                <div className="step-number"><img src={`${url}images/intelihire/sec-7/3.png`} alt="" /></div>
                <div className="step-content">
                    <h5>Schedule & Hire Seamlessly</h5>
                    <p>
                    Select top candidates, and send invites automatically.
                    Everything syncs with Google Calendar, online or in-person,
                    your workflow stays effortless.
                    </p>
                </div>
                </div>

            </div>

            {/* Right Video */}
            <div className="col-lg-6 col-xl-5 col-md-12 video-col" data-aos="fade-left" data-aos-duration="1000">
                <div className="video-wrapper">
                    <video
                    className="demo-video"
                    controls
                    poster={`${url}images/intelihire/sec-7/video-thumb.png`}
                    >
                    <source src={`${url}images/intelihire.mp4`} type="video/mp4" />
                    Your browser does not support the video tag.
                    </video>
                </div>
                <p className="watch-demo">Watch Demo</p>
            </div>

            </div>
        </div>
    </section>
  );
};

export default Section7;
